import { useState, useEffect } from 'react'
import { X } from 'lucide-react'

const STORAGE_KEY = 'desres_arithmetic_tip_dismissed'

/**
 * One-time dismissible hint shown above the first arithmetic-capable
 * field on each form. After the user dismisses it, the localStorage
 * flag suppresses it everywhere, forever.
 */
export default function ArithmeticTip() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== 'true') setShow(true)
    } catch { /* ignore */ }
  }, [])

  function dismiss() {
    setShow(false)
    try { localStorage.setItem(STORAGE_KEY, 'true') } catch {}
  }

  if (!show) return null

  return (
    <div className="flex items-center justify-between gap-3 bg-teal-950/30 border border-teal-800/40 rounded px-3 py-2 text-[11px] text-teal-300">
      <span>
        <span className="font-semibold">Tip:</span> You can type expressions like{' '}
        <code className="font-mono text-teal-200">120+30</code> in any number field.
      </span>
      <button
        type="button"
        onClick={dismiss}
        className="text-teal-400 hover:text-teal-200 shrink-0"
        aria-label="Dismiss tip"
      >
        <X size={13} />
      </button>
    </div>
  )
}
